<template>
  <el-dropdown trigger='click'>
    <span class="el-dropdown-link">
      <i  class="iconfont icon-more"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item  disabled>{{$t('lang.gapTitle')}}</el-dropdown-item>
      <el-dropdown-item :divided='true'></el-dropdown-item>
      <el-dropdown-item v-for="item in gapBehaviorList" :key="item.value" @click.native="changeGapBehavior(item.value)">{{$t(`lang.${item.label}`)}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    eventData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: Number,
      default: () => {
        0
      }
    },
    curDate: {},
    TimeQuantum: {}
  },
  data () {
    return {
      gapBehaviorList: [
        { label: 'gapMove', value: 0 },
        { label: 'gapMoveBefore', value: 1 },
        { label: 'gapMoveBeforeDay', value: 2 }
      ]
    }
  },
  created () {
    if (this.eventData.sourceType == 1) {
      this.gapBehaviorList.push({ label: 'gapLive', value: 3 })
    }
  },
  methods: {
    changeGapBehavior (type) {
      if (type == 2) {
        const h = this.$createElement
        let targetObj = null
        targetObj = h('div', null, [
          h('p', null, `${this.$t('lang.gapMoveSure')} `),
          h('p', null, `${this.$t('lang.relativeTiming')} `)
        ])
        this.$msgbox({
          title: '',
          message: targetObj,
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: this.$t('lang.Confirm'),
          cancelButtonText: this.$t('lang.cancel')
        }).then(() => {
          const endTime = this.eventData.gapEndTime
          this.sendChangeGapRequire(type, endTime)
        }).catch(() => {})
      } else if (type == 1) {
        const endTime = this.eventData.gapEndTime
        this.sendChangeGapRequire(type, endTime)
      } else {
        this.sendChangeGapRequire(type)
      }
    },
    sendChangeGapRequire (type, endTime) {
      const params = {
        programId: this.$BehaviorSyns.getProgramId(),
        eventId: this.eventData.eventId,
        deleteGapType: type,
        modelType: Outil.getProgramReceiver().modeType
      }
      if (endTime) {
        params.moveEndTime = endTime
      }
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/gapDelete'),
        data: params
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$emit('updateEvent')
          Bus.$emit('updateEventList')
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #999999
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
